<template>
  <div class="station">
    <div class="station_top" :class="{end:station.status==1}">{{station.status==0?'':'✔'}}</div>
    <div class="station_text">{{ station.name }}</div>
  </div>
</template>
<script>
export default {
  props: ["station"],
};
</script>
<style>
.station {
  flex: 1;
}
.station_top {
  width: 20px;
  height: 20px;
  border: solid 1px #1990d0;
  background: #fff;
  border-radius: 50%;
  text-align: center;
  margin-bottom: 4px;
}
.end {
  background: #0ec90e;
  color: #fff;
  border: solid 1px #15de15;
}
.station_text {
  width: 20px;
  height: 150px;
  writing-mode: tb-rl;
  line-height: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/garbage/station.vue